export default "__VITE_ASSET__cabf6fdb__"